import React from "react";
import { useTranslation } from "react-i18next";

const Guide = () => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-4">{t("guide_title")}</h1>
      <p className="text-gray-700">{t("guide_description")}</p>
    </div>
  );
};

export default Guide;
